import { ConsignmentVendorApplicationUpdatePage } from "@/features/consignment-vendor-application/pages/ConsignmentVendorApplicationUpdatePage";
import { createFileRoute } from "@tanstack/react-router";

const EDIT_SEARCH_VALUE = "1";

type ConsignmentVendorApplicationSearch = { ubah?: string };

export const Route = createFileRoute(
	"/vendor/consignment-vendor-application/update",
)({
	validateSearch: (
		search: Record<string, unknown>,
	): ConsignmentVendorApplicationSearch => ({
		ubah:
			String(search.ubah ?? "") === EDIT_SEARCH_VALUE
				? EDIT_SEARCH_VALUE
				: undefined,
	}),
	component: ConsignmentVendorApplicationRoute,
});

function ConsignmentVendorApplicationRoute() {
	const { ubah } = Route.useSearch();
	return (
		<ConsignmentVendorApplicationUpdatePage
			isEditRequested={ubah === EDIT_SEARCH_VALUE}
		/>
	);
}
